<template lang="pug">
	main.matrixTable
		button.matrixClear(
			v-if="!authorized && computed.headers.some(itm => itm.filterable)", 
			@click="clearFilters", 
			:disabled="!Object.keys(filters).length") 
			i.fas.fa-times
			span Clear Filters
		matrix-header(:cols="cols")
		matrix-body(:cols="cols")
		matrix-row-editor(v-if="authorized")
		button.matrixTop(@click="scrollTop", v-if="!top")
</template>

<script>
import Header from "@/matrix/components/Header";
import Body from "@/matrix/components/Body";
import RowEditor from "@/matrix/components/body/RowEditor";
import { mapGetters, mapMutations } from "vuex";
import { isNull, isNumber } from 'util';

export default {
  name: "Public",
  components: {
    matrixHeader: Header,
    matrixBody: Body,
    matrixRowEditor: RowEditor
	},
	data() {
		return {
			top: true
		}
	},
  computed: {
    ...mapGetters(["computed", "filters", "authorized"]),
    cols() {
      let cols = this.computed.headers.reduce((_cols, header) => {
        if (header.hasOwnProperty('columnRatio') && isNumber(header.columnRatio) && header.columnRatio > 0) {
          _cols += `${header.columnRatio}fr `;
        } else if (header.editorType === "wysiwyg") _cols += "2fr ";
        else _cols += "1fr ";
        return _cols;
      }, "");

      if (this.authorized) cols += "1fr ";

      return { gridTemplateColumns: cols };
		}
  },
  methods: {
		...mapMutations(["clearFilters"]),
		scrollTop() {
			window.scrollTo({
				top: this.$el.offsetTop,
				behavior: 'smooth'
			})
		},
		checkTop() {
			if (window.scrollY > 100) {
				this.top = false
			}
			else {
				this.top = true
			}
		}
	},
	mounted() {
		this.checkTop()
		window.addEventListener('scroll', this.checkTop)
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.checkTop)
	}
};
</script>

<style lang="scss" scoped>
.matrixTable {
  display: flex;
  flex-direction: column;
}

.matrixTop {
	position: fixed;
	bottom: 60px;
	right: 0;
	height: 40px;
	width: 40px;
	background: $empire;
	border-radius: none;
	appearance: none;
	border: none;
	outline: none;
	padding: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	box-shadow: 0 0 10px rgba($black, .2), 0 0 50px rgba($black, .075);
	@media (min-width: 1100px) {
		display: none;
	}
	&::after {
		margin-top: 7px;
		min-height: 15px;
		min-width: 15px;
		border-right: 2px solid $white;
		border-top: 2px solid $white;
		content: '';
		transform: rotate(-45deg);
	}
}

.matrixClear {
  border: none;
  align-self: flex-end;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 2rem;
  width: 2rem;
  position: relative;
  outline: none;
  cursor: pointer;
  padding: 0;
  padding-left: 90px;
  width: 122px;
  margin-bottom: 0.5rem;
  overflow: hidden;
  z-index: 1;
  margin-right: 20px;
  background: none;
  @media (min-width: 1100px) {
    margin-right: 0;
  }
  &:disabled {
    pointer-events: none;
    i {
      background: lighten($dusty, 10%);
    }
    span {
      background: lighten($dusty, 15%);
    }
  }
  &:hover {
    span {
      left: 0;
    }
  }
  i {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 0;
    min-width: 32px;
    min-height: 32px;
    background: $azure;
    transition: 0.25s ease;
    color: $white;
    &::before {
      margin-right: 0 !important;
    }
  }
  span {
    position: absolute;
    top: 0;
    z-index: -1;
    bottom: 0;
    white-space: nowrap;
    line-height: 1;
    display: flex;
    color: $white;
    align-items: center;
    padding: 0 0.5rem;
    background: darken($azure, 5%);
    font-size: 14px;
    transition: 0.25s ease;
    left: 0;
    @media (min-width: 1100px) {
      left: 100%;
    }
  }
}
</style>